import { useNavigate } from 'react-router-dom';
import { ArrowRight, type LucideIcon } from 'lucide-react';

import { Card, CardContent } from '@/components/atoms/card';
import { Button } from '@/components/atoms/button';
import { cn } from '@/lib/utils';

interface ObjectiveCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  href: string;
  color: string;
  price?: string;
}

export function ObjectiveCard({
  title,
  description,
  icon: Icon,
  href,
  color,
  price,
}: ObjectiveCardProps) {
  const navigate = useNavigate();

  return (
    <Card
      className="group cursor-pointer hover:border-primary/50 hover:shadow-lg transition-all"
      onClick={() => navigate(href)}
    >
      <CardContent className="pt-6 space-y-4">
        <div className={cn('p-3 rounded-xl w-fit', color)}>
          <Icon className="size-6" />
        </div>
        <div>
          <h3 className="font-semibold text-lg">{title}</h3>
          <p className="text-sm text-muted-foreground mt-1">{description}</p>
        </div>
        {price && (
          <p className="text-xs text-muted-foreground">{price}</p>
        )}
        <Button
          variant="outline"
          size="sm"
          className="w-full group-hover:bg-primary group-hover:text-primary-foreground transition-colors"
        >
          Créer une campagne
          <ArrowRight className="size-4 ml-2" />
        </Button>
      </CardContent>
    </Card>
  );
}
